import fr from 'vuetify/es5/locale/fr';
import en from 'vuetify/es5/locale/en';

const locales = { fr, en };
export default locales;
